export const environment = {
  neutral: true,
  maxAttachmentsvalue: 20,
  API: {
    authURL: 'https://service.monitoraggio.deppsviluppo.org/api/token/',
    authRefreshURL: 'https://service.monitoraggio.deppsviluppo.org/api/token/refresh/',
    baseURL: 'https://service.monitoraggio.deppsviluppo.org/api/',
    adminURL: 'https://service.monitoraggio.deppsviluppo.org/admin/',
    wsURL: 'wss://ws.monitoraggio-comin.deppsviluppo.org/'
  },
  branding: {
    companyName: '',
    productName: '',
    pageTitle: 'Monitoraggio',
    logo: 'assets/branding/logo-neutral.png',
    favicon: 'assets/branding/favicon-neutral.png',
    emailLogo: null,
    colors: {
      primary: '#6c757d',
      gold: '#6c757d'
    },
    footer: {
      copyrightHolder: '',
      copyrightUrl: '',
      vatNumber: '',
      links: []
    },
    loginMessage: 'Accedi per utilizzare la piattaforma di monitoraggio.'
  }
};
